export type HwcgAuthorizationState = {
  contactId: string;
  date: string;
  time: string;
  caller: string;
  description: string;
  confirmed: boolean;
};

export function createEmptyHwcgAuthorization(): HwcgAuthorizationState {
  return {
    contactId: '',
    date: '',
    time: '',
    caller: '',
    description: '',
    confirmed: false,
  };
}

export function hwcgAuthorizationComplete(
  authorization: HwcgAuthorizationState
): boolean {
  return Boolean(
    authorization.contactId.trim() &&
      authorization.date.trim() &&
      authorization.time.trim() &&
      authorization.caller.trim() &&
      authorization.description.trim() &&
      authorization.confirmed
  );
}
